var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#1C2154"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M40 30L40 43M6 30L6 43M27 30L27 43",
    transform: "translate(-445 -264) translate(264 234) translate(181 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2.5,
    d: "M27.5 24.25c.483 0 .92.196 1.237.513.317.316.513.754.513 1.237h0v3.75H3.75V26c0-.483.196-.92.513-1.237.316-.317.754-.513 1.237-.513h0z",
    transform: "translate(-445 -264) translate(264 234) translate(181 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2.5,
    d: "M22.5 4.75c.76 0 1.447.308 1.945.805.497.498.805 1.186.805 1.945h0v16.75H7.75V7.5c0-.76.308-1.447.805-1.945.498-.497 1.186-.805 1.945-.805h0z",
    transform: "translate(-445 -264) translate(264 234) translate(181 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M34.526 24.25h6.015c.94 0 1.7.761 1.7 1.7V29.639c0 .055-.044.1-.1.1h-8.644M29.296 5.25h5.964c1.657 0 3 1.343 3 3v16h-4.892",
    transform: "translate(-445 -264) translate(264 234) translate(181 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    strokeWidth: 2,
    d: "M21.698 12.919l-3.377-.517-1.512-3.216c-.118-.248-.507-.248-.625 0l-1.512 3.216-3.377.517c-.132.022-.236.116-.278.247-.041.131-.007.277.09.372l2.449 2.503-.576 3.53c-.02.138.028.276.139.356.104.08.25.095.367.03l3.01-1.667 3.025 1.666c.048.03.104.044.159.044.07 0 .146-.022.201-.073.104-.08.16-.218.139-.356l-.576-3.53 2.449-2.503c.097-.095.131-.24.09-.372-.049-.13-.153-.232-.285-.247z",
    transform: "translate(-445 -264) translate(264 234) translate(181 30)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeat);
export default __webpack_public_path__ + "static/media/icon-seat.a8a6b321.svg";
export { ForwardRef as ReactComponent };